import { rfqJobQuoteDetailsProductListStyles } from "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsProductList";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import UCSColors from "@ucs/Utils/UCSColors";
import { css } from "styled-components";

rfqJobQuoteDetailsProductListStyles.mainWrapper = {
    css: css`
        width: 100%;
        padding: 20px;
        background-color: ${UCSColors.gray10};
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 10px;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    padding: 20px 10px;
                    gap: 0;
                `,
                css`
                    gap: 0;
                `,
            ]);
        }}
    `,
};
